/* Ecochic · catálogo para la capa de lógica (PLAN v2 §3 y §4).
   Lee /collections/all?view=eco-data (solo lectura) y lo deja en el formato de web-v3:
   window.PRODUCTS, window.PRODUCTS_EXTRA e window.INGREDIENTS. También ofrece EcoCart.add. */
(function () {
  'use strict';
  var KEY = 'eco_catalog_v3_', TTL = 10 * 60 * 1000;

  // Datos desde Shopify (snippet eco-config-data → window.ECO_DATA): metaobjetos «Tipo de producto» y «Marca», nombre de la tienda
  var D = window.ECO_DATA || {};
  function internalType(pt) { var t = D.tipo ? D.tipo(pt) : null; return (t && t.interno) || pt; }
  // Marca = vendor (decisión CEO 2026-09-26, README_JOSE_02 §4.2). Si el vendor es la propia tienda o está vacío, se toma del tag o del título.
  function norm(s) { return D.norm ? D.norm(s) : String(s == null ? '' : s).toLowerCase(); }
  function brandOf(p) {
    // vendor propio de la tienda: ajuste del tema «Vendor propio» (o el nombre de la tienda)
    var v = norm(p.vendor), own = [norm(D.ownVendor), norm(D.shop)].filter(Boolean);
    if (v && own.indexOf(v) < 0) return p.vendor;
    var tags = (p.tags || []).map(norm), t = norm(p.t), B = D.marcas || [];
    for (var i = 0; i < B.length; i++) { var b = norm(B[i]); if (tags.indexOf(b) >= 0 || t.indexOf(b) >= 0) return B[i]; }
    return '';
  }
  // precio al cliente: el JSON eco-data trae € sin IVA; aquí se aplica el IVA una sola vez (ECO_DATA.priceVat, en céntimos)
  function priceVat(eur) { var c = Math.round(Number(eur) * 100); return ((D.priceVat ? D.priceVat(c) : c) / 100).toFixed(2); }
  function ingredients() {
    try {
      return JSON.parse(document.getElementById('eco-ingredients').textContent).map(function (i) {
        return { slug: i.slug, nombre: i.nombre, inci: i.inci, para_piel: i.para_piel || [], dolencias: i.dolencias || [], que_hace: i.que_hace, url: i.url };
      });
    } catch (e) { return []; }
  }
  function toWeb(raw) {
    var P = [], EX = {};
    raw.forEach(function (r) {
      var p = { h: r.h, u: r.u || '', t: r.t, type: (r.pt ? internalType(r.pt) : '') || EcoT('core.otros'), product_type: r.pt, tags: r.tags || [], desc: r.desc || '',
        vendor: r.v || '', inci: r.inci || '', ok: r.ok === true, price: r.price != null ? priceVat(r.price) : '', img: r.img || '', vid: r.vid, available: r.av, slow: r.sb === true,
        piel: r.piel || [], dolencias: r.dol || [] };
      p.brand = brandOf(p);
      P.push(p);
      EX[r.h] = { activos: (r.act || []).map(function (s) { return String(s).replace(/-/g, ' '); }), modo_uso: r.modo || '', piel: r.piel || [], dolencias: r.dol || [], beneficios: r.ben || [] };
    });
    return { P: P, EX: EX };
  }
  function cacheGet(h) {
    try { var c = JSON.parse(sessionStorage.getItem(KEY + h) || 'null'); if (c && Date.now() - c.at < TTL) return c.raw; } catch (e) {}
    return null;
  }
  function cacheSet(h, raw) { try { sessionStorage.setItem(KEY + h, JSON.stringify({ at: Date.now(), raw: raw })); } catch (e) {} }

  function fetchPage(h, n) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'collections/' + encodeURIComponent(h) + '?view=eco-data&page=' + n, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }
  var loading = {};
  // handle = colección a leer (por defecto «all», el catálogo entero)
  function load(handle) {
    var h = handle || 'all';
    if (loading[h]) return loading[h];
    var cached = cacheGet(h);
    var src = cached ? Promise.resolve(cached) : fetchPage(h, 1).then(function (first) {
      var all = first.products || [], rest = [];
      for (var i = 2; i <= (first.pages || 1); i++) rest.push(fetchPage(h, i));
      return Promise.all(rest).then(function (pages) {
        pages.forEach(function (pg) { all = all.concat(pg.products || []); });
        cacheSet(h, all);
        return all;
      });
    });
    loading[h] = src.then(function (raw) {
      var w = toWeb(raw);
      window.PRODUCTS = w.P; window.PRODUCTS_EXTRA = w.EX; window.INGREDIENTS = ingredients();
      return w.P;
    });
    loading[h].catch(function () { delete loading[h]; });
    return loading[h];
  }

  // Cesta nativa de Eurus (mismo patrón que frequently-bought-together.js)
  function byHandle(h) { var P = window.PRODUCTS || []; for (var i = 0; i < P.length; i++) if (P[i].h === h) return P[i]; return null; }
  function add(handles) {
    var items = [];
    (Array.isArray(handles) ? handles : [handles]).forEach(function (h) { var p = byHandle(h); if (p && p.vid && p.available !== false) items.push({ id: p.vid, quantity: 1 }); });
    if (!items.length) return Promise.resolve(0);
    var helper = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
    var sections = helper && helper.getSectionsToRender ? helper.getSectionsToRender() : [];
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: sections.map(function (s) { return s.id; }) })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && res.status == 422) throw new Error(res.description || EcoT('core.no_se_pudo_anadir'));
      // mismo orden que frequently-bought-together.js de Eurus: secciones, cajón o aviso, contador y evento
      try {
        sections.forEach(function (sec) {
          var el = document.querySelector(sec.selector);
          if (el && res.sections && res.sections[sec.id] && typeof getSectionInnerHTML === 'function') el.innerHTML = getSectionInnerHTML(res.sections[sec.id], sec.selector);
        });
      } catch (e) {}
      try {
        var noti = window.Alpine && Alpine.store('xCartNoti');
        if (noti && noti.enable) noti.setItem(res);
        else {
          try { if (window.Alpine && Alpine.store('xMiniCart')) Alpine.store('xMiniCart').openCart(); } catch (e2) {}
          document.dispatchEvent(new CustomEvent('eurus:cart:redirect')); // con carrito en página, Eurus lleva a /cart
        }
      } catch (e) {}
      try {
        var bubble = document.querySelector('#cart-icon-bubble span');
        if (helper && bubble) helper.currentItemCount = parseInt(bubble.innerHTML, 10);
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      return items.length;
    });
  }

  window.EcoCatalog = { load: load, byHandle: byHandle, norm: norm };
  window.EcoCart = { add: add };
})();
